<template>
  <v-row
    no-gutters
    justify=center
    class="main--text">
    <v-col>
      <v-card
        width=800>
        <v-container
          fluid
          v-if="offers.length() > 0">
          <h3>{{ student.fullName() }}さんへの{{ offers.length() }}件の授業応募に回答</h3>
        </v-container>
        <v-container
          fluid
          v-for="offer in offers.get()"
          :key="offer.id">
          <v-offer-from-each-teacher
            :offer="offer"
            @agree-button-click="$emit('agree-event', offer)"
            @disagree-button-click="$emit('disagree-event', offer)"/>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import VOfferFromEachTeacher from "@/components/organisms/parent/VOfferFromEachTeacher.vue"

export default {
  components: {
    VOfferFromEachTeacher
  },
  props: {
    student: Object,
    offers: Object
  }
}
</script>
